import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
//import router from '@/router/index'
//import store from '@/store/index'
import TokenExpireDialogModal from '@/components/core/dialogs/TokenExpireDialogModal.vue';

function TokenExpireDialog(bearer) {
	let modal = document.createElement('div');
	document.body.appendChild(modal);
	return new Promise((resolve) => {
		let vModal = new Vue({
			/*router,
            store,*/
			vuetify,
			el: modal,
			components: {
				TokenExpireDialogModal,
			},
			data: {
				showDialog: true,
				token: bearer,
			},
			methods: {
				kill() {
					modal = vModal.$el;
					vModal.$destroy();
					if (modal.parentNode) {
						modal.parentNode.removeChild(modal);
					}
				},
				onConfirm(token) {
					this.showDialog = false;
					resolve(token);
					this.kill();
				},
				onCancel() {
					this.showDialog = false;
					resolve(null);
					this.kill();
				},
			},
			template: `<token-expire-dialog-modal v-if="showDialog" :showDialog="showDialog"  @cancel="onCancel" @confirm="onConfirm" :token="token" />`,
		});
	});
}

export default TokenExpireDialog;
